import {Overlay} from "@/components/layouts/popup/Overlay";
import {RootPopup} from "@/components/layouts/popup/RootPopup";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";

export const InfoPopup = ({width}) => {
  const {popupContent, closePopup} = usePopup();

  const handleClose = () => {
    if (popupContent.onClose) {
      popupContent.onClose();
    }
    closePopup();
  };

  return (
    <>
      {popupContent.content && (
        <Overlay>
          <RootPopup
            width={width}
            close={popupContent.closeButton}
            onClick={handleClose}
          >
            {popupContent.content}
          </RootPopup>
        </Overlay>
      )}
    </>
  );
};
